export const transitionSceneId = 'Transition';
export const farmTransitionSceneId = 'FarmTransition';
export const plinkoTransitionSceneId = 'PlinkoTransition';
export const preloadSceneId = 'Preload';
export const audioSceneId = 'Sound';

export enum GameScene {
    WORLD = 'World',
    LEVEL = 'Level',
    LUCKY_TURNIPS = 'LuckyTurnips',
    MY_PET_MINI_GAME = 'MyPetMiniGame',
    FARM = 'Farm',
    PLINKO = 'Plinko',
}
